import React, { useState } from 'react';
import SectionWrapper from '../shared/SectionWrapper';
import Button from '../shared/Button';

const HeroSection = () => {
  const [showPlayer, setShowPlayer] = useState(false);

  const handlePlay = () => setShowPlayer(true);

  return (
    <SectionWrapper 
      id="hero"
      gradient="from-dark-950 to-dark-875"
      overlay="bg-[radial-gradient(circle_at_15%_25%,rgba(46,204,113,0.06),transparent_65%)]"
      className="min-h-[40vh] pt-24 md:pt-14 pb-1 flex items-center"
      scrollMargin={true}
    >
      <div className="flex flex-col items-center text-center">
        <h1 className="text-2xl md:text-3xl lg:text-4xl font-bold text-white mb-2 leading-tight max-w-3xl mx-auto glow-title">
          Querendo vender o seu console usado e sair com um de nova geração? 
        </h1>
        
        <p className="text-base text-grayText mb-6 max-w-xl">
        Fale comigo agora e venha garantir logo o seu!
        </p>
        
        {/* <div className="w-full max-w-4xl mx-auto mb-8">
          <div className="relative overflow-hidden aspect-w-16 aspect-h-9 rounded-lg border border-dark-800/50 shadow-lg bg-dark-900 flex items-center justify-center">
            {!showPlayer ? (
              <button
                className="video-placeholder w-full h-full absolute top-0 left-0 flex items-center justify-center bg-black/60"
                style={{ cursor: 'pointer', border: 'none', padding: 0 }}
                onClick={handlePlay}
                aria-label="Assistir vídeo"
              >
                <img
                  src="/images/webp/thumb.webp"
                  alt="Assista ao vídeo VSL"
                  className="w-full h-full object-cover rounded-lg"
                  style={{ display: 'block' }}
                />
                <span className="play-button" style={{ position: 'absolute', left: '50%', top: '50%', transform: 'translate(-50%, -50%)', zIndex: 2 }}>
                  <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="32" cy="32" r="32" fill="rgba(34,197,94,0.8)"/>
                    <polygon points="26,20 48,32 26,44" fill="white"/>
                  </svg>
                </span>
              </button>
            ) : (
              <iframe
                src="https://player.vimeo.com/video/1094186107?h=0ee1cb604e&badge=0&autopause=0&player_id=0&app_id=58479&title=0&byline=0&portrait=0"
                frameBorder="0"
                allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share"
                allowFullScreen
                title="VENHA PARA A GAMA GAMES!"
                className="w-full h-full rounded-lg"
                style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
              ></iframe>
            )}
          </div>
        </div> */}
        
        <div className="flex flex-col sm:flex-row gap-4 w-full max-w-lg mx-auto">
          <Button 
            href="https://api.whatsapp.com/send/?phone=554799089366" 
            variant="primary" 
            size="lg"
            className="w-full sm:flex-1"
          >
            <i className="fab fa-whatsapp mr-2"></i> Quero Minha Avaliação Agora
          </Button>
          
          <Button 
            href="#trade-process"
            variant="secondary"
            size="lg"
            className="w-full sm:flex-1"
          >
            <i className="fas fa-exchange-alt mr-2"></i> Como Funciona a Troca
          </Button>
        </div>
      </div>
    </SectionWrapper>
  );
};

export default HeroSection; 